export default __webpack_public_path__ + "static/media/dopes5.363971d2.jfif";